
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import { VCodeMirror } from 'vue3-code-mirror'
import useValidate from '@vuelidate/core'
import qbeDescriptor from './DatasetManagementDerivedDatasetDescriptor.json'
import Card from 'primevue/card'
import Dialog from 'primevue/dialog'
import QBE from '@/modules/qbe/QBE.vue'

export default defineComponent({
    components: { Card, Dialog, VCodeMirror, QBE },
    props: { parentValid: { type: Boolean }, selectedDataset: { type: Object as any }, qbeDatasets: { type: Array as any } },
    emits: ['touched', 'qbeDialogClosed', 'qbeDialogSaved'],
    data() {
        return {
            qbeDescriptor,
            dataset: {} as any,
            v$: useValidate() as any,
            qbeQuery: '' as any,
            qbeQueryDialogVisible: false,
            qbeVisible: false,
            codeMirror: {} as any,
            qbeDataset: {} as any,
            sourceDataset: {} as any,
            selectedBusinessModel: {} as any,
            datsetBmChanged: false,
            getQueryFromDataset: false,
            codemirrorOptions: {
                readOnly: true,
                mode: 'text/javascript',
                indentWithTabs: true,
                smartIndent: true,
                lineWrapping: true,
                matchBrackets: true,
                autofocus: true,
                theme: 'eclipse',
                lineNumbers: true
            }
        }
    },
    created() {
        this.dataset = this.selectedDataset
        this.setupCodeMirror()
    },
    watch: {
        selectedDataset() {
            this.dataset = this.selectedDataset
            this.setupCodeMirror()
        }
    },
    validations() {
        const qbeFieldsRequired = (value) => {
            return this.dataset.dsTypeCd != 'Qbe' || value
        }
        const customValidators: ICustomValidatorMap = { 'qbe-fields-required': qbeFieldsRequired }
        const validationObject = { dataset: createValidations('dataset', qbeDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {
        setupCodeMirror() {
            const interval = setInterval(() => {
                if (!this.$refs.codeMirror) return
                this.codeMirror = (this.$refs.codeMirror as any).cminstance as any
                setTimeout(() => {
                    this.codeMirror.refresh()
                }, 0)
                clearInterval(interval)
            }, 200)
        },
        openQbeQueryDialog() {
            if (typeof this.dataset.sqlQuery === 'string') {
                this.qbeQuery = this.dataset.sqlQuery
            }
            this.qbeQueryDialogVisible = true
        },
        openDatasetInQBE() {
            /*             if (this.$route.name === 'new-dataset') {
                this.qbeDataset = deepcopy(this.selectedBusinessModel)
                this.getQueryFromDataset ? (this.qbeDataset.qbeJSONQuery = this.dataset.qbeJSONQuery) : ''
            } else {
                if (this.datsetBmChanged) {
                    this.qbeDataset = deepcopy(this.selectedBusinessModel)
                } else {
                    this.qbeDataset = deepcopy(this.dataset)
                }
            } */

            this.qbeDataset = null
            this.sourceDataset = this.dataset.sourceDatasetLabel

            this.qbeVisible = true
        },
        onQbeDialogClose() {
            this.qbeVisible = false
        },
        onQbeDialogSave(query) {
            this.dataset.qbeJSONQuery = query
            this.datsetBmChanged = false
            this.getQueryFromDataset = true
        }
    }
})
